namespace Nobox.CRM {
    export interface GrouptargetsRow {
        Id?: number;
        GrpId?: number;
        Grp?: string;
        Years?: number;
        Jan?: number;
        Feb?: number;
        Mar?: number;
        Apr?: number;
        May?: number;
        Jun?: number;
        Jul?: number;
        Agus?: number;
        Sep?: number;
        Okto?: number;
        Nov?: number;
        Dec?: number;
        Currencies?: string;
        Cry?: string;
        Target?: number;
        Total?: number;
        InBy?: number;
        In?: string;
        UpBy?: number;
        Up?: string;
    }

    export namespace GrouptargetsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Grp';
        export const localTextPrefix = 'Nobox.Grouptargets';
        export const lookupKey = 'Nobox.Grouptargets';

        export function getLookup(): Q.Lookup<GrouptargetsRow> {
            return Q.getLookup<GrouptargetsRow>('Nobox.Grouptargets');
        }
        export const deletePermission = 'Deals:Delete';
        export const insertPermission = 'Deals:Modify';
        export const readPermission = 'Deals:View';
        export const updatePermission = 'Deals:Modify';

        export declare const enum Fields {
            Id = "Id",
            GrpId = "GrpId",
            Grp = "Grp",
            Years = "Years",
            Jan = "Jan",
            Feb = "Feb",
            Mar = "Mar",
            Apr = "Apr",
            May = "May",
            Jun = "Jun",
            Jul = "Jul",
            Agus = "Agus",
            Sep = "Sep",
            Okto = "Okto",
            Nov = "Nov",
            Dec = "Dec",
            Currencies = "Currencies",
            Cry = "Cry",
            Target = "Target",
            Total = "Total",
            InBy = "InBy",
            In = "In",
            UpBy = "UpBy",
            Up = "Up"
        }
    }
}
